import moment from 'moment';
import React, { Fragment, useState, useEffect } from 'react';
import { Col, Container, Row, Card, CardBody, Progress, Button } from 'reactstrap';
import history from '../../history';

const PatientSurveyProfile = ({ }) => {
    return (
        <Fragment>
            <Col md={12} lg={5} xl={3} xs={12}>
                <Card>
                    <CardBody style={{ padding: 0 }}>
                        <div className='dashboard__visitors-technologist'>
                            <div className='title'><h5><b>Encuesta</b></h5></div>
                            <b>Entrar a modulo de Encuestas al Paciente</b>
                            <Button
                                style={{ margin: 20 }}
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    history.push({
                                        pathname: process.env.PUBLIC_URL + '/assitencial/survey-patients'
                                    });
                                }}
                            >
                                Entrar
                            </Button>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    )
}

export default PatientSurveyProfile